export default "__VITE_ASSET__DKWTz8VQ__"